import { string, bool, func, object, number } from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import classNames from 'classnames/bind';
import size from 'lodash/size';
import isEmpty from 'lodash/isEmpty';
import noop from 'lodash/noop';
import get from 'lodash/get';
import { useCustomOptionValidation } from './CustomOptionValidation';
import Messages, { messagesLevels, messageTypes } from '../Messages';

import * as styles from './CustomOptions.css';

const cx = classNames.bind(styles);

const CustomOptionsInput = (props) => {
    const {
        className,
        disableFraction,
        isMTM = false,
        isPersonalize,
        input,
        isATCClicked,
        maxRange,
        messageError,
        onBlur,
        placeholder,
        title,
        type,
        validate: {
            dataItem = {},
            personalizedItemType = false,
            optionName = '',
            CustomOptionsMessages = {},
        },
        enableErrorSizing,
    } = props;
    const selectedCustomOptions = useSelector((state) =>
        get(state, 'customOptions.selectedCustomOptions', [])
    );
    const enteredValue = selectedCustomOptions.find((item) => item.type === dataItem.name);
    const [inputValue, setInputValue] = useState(enteredValue?.value || '');
    const hookParam = {
        CustomOptionsMessages,
        dataItem,
        disableFraction,
        isMTM,
        optionName,
        personalizedItemType,
        validationType: 'input',
    };
    const formError = useCustomOptionValidation(hookParam, inputValue);

    const onInputChange = (event) => {
        const { value } = event.target;
        setInputValue(value);
    };

    const showMessages = isATCClicked && size(messageError) > 0 && !isEmpty(formError);
    const inputTheme = showMessages && formError ? formError.type : '';
    const messagesToShow = showMessages && formError ? [formError] : [];
    if (showMessages && formError) {
        formError.type = messageTypes.warning;
    }

    return [
        <div
            className={dt([
                'order-[-1]',
                'mt-1',
                'mr-0',
                'mb-2',
                'ml-0',
                'whitespace-nowrap',
                'md:h-[10px]',
                isPersonalize && 'whitespace-normal',
                isPersonalize && 'mdOnly:w-auto',
                isPersonalize && 'lg:h-[25px]',
            ])}
        >
            {!enableErrorSizing && (
                <Messages
                    level={messagesLevels.inline}
                    messages={messagesToShow}
                    hasClose={false}
                />
            )}
        </div>,
        <div
            className={`${dt([
                'capitalize',
                'text-sm',
                'font-normal',
                'font-open-sans',
                'min-h-[15px]',
                'text-gray-70',
                'sm:!mx-0',
                'sm:!mb-2',
            ])} ${cx('row')}`}
        >
            {title}
        </div>,
        <div className={className}>
            <input
                className={inputTheme}
                type={type}
                maxLength={maxRange}
                data-automation-id={`custom-options-input-${type}`}
                {...input}
                onChange={onInputChange}
                placeholder={placeholder}
                onBlur={onBlur}
                value={inputValue}
            />
        </div>,
    ];
};

CustomOptionsInput.defaultProps = {
    isMTM: false,
    disableFraction: noop,
    validate: {},
    isPersonalize: false,
    title: '',
    input: {},
    className: '',
    messageError: {},
    type: '',
    maxRange: 2,
    placeholder: '',
    isATCClicked: false,
    onBlur: noop,
};

CustomOptionsInput.propTypes = {
    isMTM: bool,
    disableFraction: func,
    validate: object,
    isPersonalize: bool,
    title: string,
    input: object,
    className: string,
    messageError: object,
    type: string,
    maxRange: number,
    placeholder: string,
    isATCClicked: bool,
    onBlur: func,
};

export default CustomOptionsInput;
